// Sanal POS sağlayıcı kaydı. Ortak kolonlara ek olarak sağlayıcıya özel
// (extra) alanlar da (ör. N Kolay sx_cancel / sx_list) dinamik olarak eklenir.
export class SanalPosEntity {
    payment_provider_id!: number;
    code: string = "";
    name: string = "";
    api_url: string = "";
    merchant_no: string = "";
    terminal_no: string = "";
    api_user: string = "";
    api_password: string = "";
    api_key: string = "";
    api_secret: string = "";
    is_test: number = 1;
    is_active: number = 0;
    is_default: number = 0;
    no: number = 0;

    // Sağlayıcıya özel dinamik alanlar (sx_cancel, sx_list ...)
    [key: string]: any;
}

// Panelin dinamik form üretmesi için sağlayıcı alan şablonu
export interface SanalPosField {
    key: string;
    label: string;
    type: string;      // text | password
    secret?: boolean;
    extra?: boolean;
}

export interface SanalPosTemplate {
    code: string;
    name: string;
    fields: SanalPosField[];
}
